/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 * Subscribers page constants.
 *
 * @author Dmitriy Kvon
 * @author Nikolay Sviridov
 * @version 1.32.0
 * @since 1.17.0
 */
export enum EPageSubscriberConstants {
    delete = 'delete',
    import = 'import',
    wizardMultiSearch = 'wizardMultiSearch',
    wizardImportSubscribersLimits = 'wizardImportSubscribersLimits',
}
